const selectors = (selector, attribute = 'behaviour') => {
    const main = (thunk) => thunk(attribute, selector)

    let str = () => main(() => `[data-${attribute}="${selector}"]`)
    if (selector.includes('.') || selector.includes('#')) {
        str = () => main(() => selector)
    }
    const node = () => document.querySelector(str())
    const nodeFrom = (el) => el.querySelector(str())
    const nodes = () => [...document.querySelectorAll(str())]
    const nodesFrom = (el) => [...el.querySelectorAll(str())]

    return {
        node,
        nodeFrom,
        nodes,
        nodesFrom,
        str,
    }
}

/**
 * Generates a function comment for a given function body.
 *
 * @param {string} selector - The data attribute value e.g data-behaviour="the-value"
 * @param {string} attribute - The attribute to be used, default is "behaviour" i.e data-behaviour
 * @returns {unknown} - returns a node, array of nodes or string
 */
export const _ = (selector, attribute = 'behaviour') => {
    return selectors(selector, attribute)
}

/**
 *
 * @param {array} els - node array
 * @param {string} className - class name to toggle
 *
 */

export const toggleClasses = (els, className) => {
    els.map((el) => {
        el.classList.toggle(className)
    })
}

/**
 *
 * @param {array} els - node array
 * @param {string} className - class name to add
 *
 */

export const addClasses = (els, className) => {
    els.map((el) => {
        el.classList.add(className)
    })
}

/**
 *
 * @param {array} els - node array
 * @param {string} className - class name to add
 *
 */

export const removeClasses = (els, className) => {
    els.map((el) => {
        el.classList.remove(className)
    })
}
